<template>
  <div class="footer">
    <div class="main">
      <el-row class="top-desc">
        <el-col class="logo" :sm="12" :xs="24">
          <img src="@images/logo-large.png"  alt=""><span class="logo-text">gamai</span>
        </el-col>
      </el-row>
      <el-row class="link-list">
        <span v-for="item in links" :key="item.text" :sm="4" :xs="24"><a href="javascript:void(0);" @click="jump(item.path, item.target)">{{item.text}}</a></span>
      </el-row>
    </div>
    <el-row class="declaration">
      <el-col :sm="12" :xs="24">
        <p class="copyright">Copyright © 2025. All Rights Reserved</p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      links: [
        {
          text: 'For Buyer',
          path: '/',
          target: 'Advertise'
        },
        {
          text: 'For Developer',
          path: '/',
          target: 'Monetize'
        },
        {
          text: 'About Us',
          path: '/',
          target: 'About'
        },
        {
          text: 'Contact Us',
          path: '/contact',
          target: 'Contact'
        },
        {
          text: 'Privacy Policy',
          path: '/privacy-policies',
          target: 'Privacy'
        },
      ]
    };
  },
  methods: {
    jump(path, target) {
      const isNotInHome = this.$router.currentRoute.path !== path;
      // if (path === '/privacy-policies') {
      //   return;
      // }
      if (isNotInHome) {
        this.$router.push({
          path,
          query: {t: target}
        })
      } else {
        location.href = `#${target}`;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.footer {
  background: rgba(0, 0, 0, 0.65);
  position: relative;
  z-index: 1;
  margin: 0 auto;
  .main {
    padding: px2rem(15) px2rem(100);
    .top-desc {
      height: px2rem(80);
      .logo {
        text-align: left;
        height: 100%;
        position: relative;
        align-items: center;
        display: flex;
        img {
          max-height: px2rem(35);
          vertical-align: middle;
        }
        .logo-text {
          font-size: px2rem(24);
          color: #fff;
          margin-left: px2rem(10);
          line-height: px2rem(35);
          height: px2rem(35);
          vertical-align: middle;
          font-weight: bolder;
        }
      }
    }
    .link-list {
      text-align: left;
      margin-bottom: px2rem(15);
      span {
        display: inline-block;
        margin-right: px2rem(40);
        a {
          color: rgba(#fff, .8);
          font-size: px2rem(16);
          font-weight: bolder!important;
          letter-spacing: 0.2px;
          font-family: "Montserrat", Sans-serif;
          line-height: 1.5;
        }
      }
    }
  }
  .declaration {
    padding: 0 px2rem(100);
    text-align: center;
    height: px2rem(42);
    line-height: px2rem(42);
    margin: 0 auto;
    font-size: px2rem(12);
    /* identical to box height */
    background: #333;
    color: #ffffff;
    .copyright {
      text-align: left;
      margin: 0;
    }
  }
}
</style>
